import styled from 'styled-components';

export const Comment = styled.p`
align-self: end;
line-height: 1.5em;
text-align: justify;
font-style: italic;
margin: 8px;

@media (max-width: ${({ theme }) => theme.breakPoints.tabletMax}) {
  font-size: 12px;  
}
`;

export const SummaryBox = styled.div`
display: grid;
grid-template-rows: repeat(6, auto) ;
height: 100%;
  h2 {
    font-size: 14px;
     margin: 8px;
  } 

  p {
  padding: 0;
   margin: 8px;
  }

    @media (max-width: ${({ theme }) => theme.breakPoints.tabletMax}) {
    font-size: 13px;  
  }

`;

export const SummaryWrapper = styled.div`
margin: 10px;
padding: 10px;
display: grid;
grid-template-rows: auto 1fr;
font-size: 14px; 
background-color: ${({ theme }) => theme.colors.bonjour};
border-radius: 8px;
box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2), 
              0 6px 14px rgba(0, 0, 0, 0.25);
  

`;